document.addEventListener('DOMContentLoaded', () => {
  const blocks = document.querySelectorAll('.js-collection-desc');
  if (!blocks.length) return;

  blocks.forEach((block) => {
    const btn = block.querySelector('.js-collection-desc-toggle');
    const content = block.querySelector('.js-collection-desc-content');
    if (!btn || !content) return;

    const previewHeight = 180;

    // Hide button if content doesn't exceed preview
    if (content.scrollHeight <= previewHeight + 20) {
      btn.style.display = 'none';
      block.dataset.collapsed = 'false';
      return;
    }

    btn.addEventListener('click', () => {
      const expanded = block.classList.toggle('is-expanded');
      block.dataset.collapsed = expanded ? 'false' : 'true';
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      btn.textContent = expanded ? 'Read less' : 'Read more';
    });
  });
});
